import { ColumnDetails } from '../../../../../apps/webcomponents/src/grid/types/common';
import { getFormattedDateTime, TimestampFormat } from '@nirvana/shared/time';
import { gridCustomHtmlRenderer } from '../../../../../apps/webcomponents/src/grid/utils/renderers';
import { htmlEncode } from '../../../../../apps/webcomponents/src/utils/escape.utils';
import { isEmpty } from '@nirvana/shared/basic-types/object';

export function dateRenderer(rowData, columnDetails: ColumnDetails<any, any>) {
  const cellValue = rowData.item[columnDetails.key];

  if (isEmpty(cellValue)) {
    return '-';
  }

  const timezone = this.dependencies.getTimezone();
  const locale = this.dependencies.getUserLanguage();
  const dateFormatted = getFormattedDateTime(TimestampFormat.EVENTS, cellValue, timezone, locale);

  return gridCustomHtmlRenderer(`<span class='cell-label'>${htmlEncode(dateFormatted)}</span>`);
}
